import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { TENANT_API_CONFIG } from './tenant-config.token';
import { DomainDataResponse, DomainInfo } from './tenant.types';

/**
 * Thin HTTP wrapper for the domain-data endpoint. Mirrors
 * `fb-shipper-frontend/src/app/services/index.util.service.js`'s
 * `getDomainData()` (line 1793) — same path, same query parameter, same
 * `data.data` envelope unwrap.
 */
@Injectable({ providedIn: 'root' })
export class TenantApiService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(TENANT_API_CONFIG);

  /**
   * Fetch the tenant's branding + feature-flag bundle.
   *
   * @param domainName — fully-resolved hostname (the caller is responsible
   *   for swapping `localhost` / `192.168.*` for the configured tenant
   *   hostname; the same resolution as the `referer-domain` interceptor).
   */
  getDomainData(domainName: string): Observable<DomainInfo> {
    const params = new HttpParams().set('domain_name', domainName);
    return this.http
      .get<DomainDataResponse>(`${this.config.baseUrl}/domain-data`, { params })
      .pipe(map((res) => res.data));
  }
}
